export const GET_ARTICLES_ENDPOINT = '/umbraco/api/articleapi/getarticles';
export const GET_CASE_STUDIES_ENDPOINT = '/umbraco/api/casestudyapi/getcasestudies';
export const GET_PRODUCTS_ENDPOINT = '/umbraco/api/productsapi/getproducts';
export const GET_COMPANIES_ENDPOINT = '/umbraco/api/groupcompanyapi/getgroupcompanies';
export const GET_GEOCODE_ENDPOINT = '/umbraco/api/geocode/getlocation';
export const GET_LOCATIONS_ENDPOINT = '/umbraco/api/locations/getlocations';
export const GET_NEWSLETTER_ARTICLES_ENDPOINT = '/umbraco/api/newsletterarticleapi/getnewsletterarticles';
export const GET_SEARCH_ENDPOINT = '/umbraco/api/search/search';
export const GET_SUGGESTIONS_ENDPOINT = '/umbraco/api/search/typeahead';
